import React from "react";
import EpCallingV2 from "./EpCallingV2";

const EpCallingWrapper = ({ sessionData, onBack }) => {
  return (
    <div className="animated fadeInDown faster">
      <button
        className="btn btn-sm mb-3"
        onClick={onBack}
        style={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          color: "#475569",
          borderRadius: 8,
          padding: "7px 16px",
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        <i className="fa fa-arrow-left mr-2" style={{ fontSize: 11 }} />
        Retour à la session
      </button>
      <EpCallingV2
        sessionData={sessionData}
        onCallingDone={() => {
          sessionData.saveCalling();
          onBack();
        }}
      />
    </div>
  );
};

export default EpCallingWrapper;
